import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <Link to="/" style={styles.logo}>← Back to Home</Link>
        <h1 style={styles.title}>Reset Password</h1>
        {sent ? (
          <div className="alert alert-success">
            If an account exists for {email}, a password reset link has been sent. Check your inbox.
          </div>
        ) : (
          <>
            <p style={styles.sub}>Enter your email and we'll send you a reset link.</p>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit} style={styles.form}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required />
              </div>
              <button className="btn btn-primary btn-lg" type="submit" style={{ width: '100%' }} disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}
        <p style={{ textAlign: 'center', fontSize: 14 }}><Link to="/login">Back to Login</Link></p>
      </div>
    </div>
  );
}

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally { setLoading(false); }
  };

  if (!token) return (
    <div style={styles.root}><div style={styles.card}><p>Invalid reset link. <Link to="/forgot-password">Request a new one.</Link></p></div></div>
  );

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <h1 style={styles.title}>Set New Password</h1>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <input className="input" type="password" placeholder="Min. 8 characters" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <input className="input" type="password" placeholder="Repeat password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
          </div>
          <button className="btn btn-primary btn-lg" type="submit" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Saving...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;

const styles = {
  root: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--slate-50)', padding: 20 },
  card: { background: 'white', border: '1px solid var(--color-border)', borderRadius: 20, padding: '40px', width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 20, boxShadow: 'var(--shadow-lg)' },
  logo: { fontSize: 14, color: 'var(--color-primary)', textDecoration: 'none' },
  title: { fontFamily: 'var(--font-display)', fontSize: 26, color: 'var(--slate-900)' },
  sub: { fontSize: 15, color: 'var(--color-text-muted)' },
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
};
